import posthtml from 'posthtml/lib';
const adComponent = t => ({
  tag: 'mj-section',
  attrs: {
    padding: '0',
    'css-class': 'ad-section',
    'full-width': 'full-width',
    'background-color': '#2a2c2e'
  },
  content: [{
    tag: 'mj-column',
    attrs: {
      width: '100%'
    },
    content: [{
      tag: 'mj-text',
      attrs: {
        width: '100%',
        color: '#FFFFFF',
        align: 'center',
        padding: '12px 10px',
        'container-background-color': '#2a2c2e',
        'font-family': 'helvetica,sans-serif',
        'font-size': '14px',
        'line-height': '18px'
      },
      content: [{
        tag: 'span',
        attrs: {
          style: 'word-break: keep-all;'
        },
        content: [`${t('COMPOSER.FOOTER.EM.AD.CREATED_BY')} `,
        // whitespace after end of sentence?
        {
          tag: 'a',
          attrs: {
            'css-class': 'ad-section-link',
            style: 'text-decoration:underline;color:#fff;display:inline-block;',
            href: 'https://www.wix.com?utm_campaign=vir_promote_em_footer_wixads&referralInfo=SO_LP',
            target: '_blank',
            rel: 'noopener noreferrer'
          },
          content: [t('COMPOSER.FOOTER.EM.AD.EXPLORE_MORE')]
        }]
      }]
    }]
  }]
});
export const insertAd = (mjml, t) => {
  const ad = tree => {
    tree.match({
      tag: 'mj-body'
    }, node => {
      node.content.push(adComponent(t));
      return node;
    });
  };
  const withAd = posthtml([ad]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withAd.html;
};
//# sourceMappingURL=insert-ad.js.map